module.exports = __webpack_public_path__ + "static/media/dark mock.569414a5.png";